export const DATA_TEST_ID = {
  LOGIN_FORM: {
    EMAIL: 'email',
    PASSWORD: 'password',
    SUBMIT_BTN: 'btn-submit',
  },
  ORDER_FORM: {
    APARTMENT_NO: 'apartmentNo',
    CITY: 'city',
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    QUANTITY: 'quantity',
    STATE: 'state',
    STREET: 'street',
    ZIP_CODE: 'zipCode',
  },
};
